﻿import {translation} from "@2d-front-monorepo/core";
import {MvvmValidation} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {useMemo} from "react";

const countries: Record<string, RegExp> = {
	"USA": /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
	"AUS": /^(\+?\(61\)|\(\+?61\)|\+?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/
};

export default function usePhoneRequiredPolicy(countryId: string): MvvmValidation<string> {
	return useMemo<MvvmValidation<string>>(() => ({
		required: translation(PermitTranslations.validation__phone__required),
		validate: function (email: string | undefined): string | undefined {
			if (countries[countryId].test(email ?? "")) {
				return undefined;
			}

			return translation(PermitTranslations.validation__phone__invalid);
		}
	}), []);
}
